import { Component, OnInit } from '@angular/core';
import { Observable, forkJoin, map, of, switchMap } from 'rxjs';


@Component({
  selector: 'app-warehouse-section-selector',
  templateUrl: './warehouse-section-selector.component.html',
  styleUrls: ['./warehouse-section-selector.component.scss'],
})
export class WarehouseSectionSelectorComponent implements OnInit {
  warehouses: any[] = [];
  selectedWarehouse: any = null;

  constructor(
    
  ) {}

  ngOnInit(): void {
    this.warehouses = [
      {
        name: 'Amazon Illescas',
        id: 'Amazon',
      }
    ];

    this.selectedWarehouse= this.warehouses[0]
    
  }

}
